class CartFreeGift extends HTMLElement {
  connectedCallback() {
    this.GIFT_IDS = (this.dataset.giftIds || '')
      .split(',')
      .map(Number)
      .filter(Boolean);
    this.DEFAULT_GIFT_ID = parseInt(this.dataset.defaultGiftId) || this.GIFT_IDS[0];
    this.GIFT_THRESHOLD = 6000;
    this.isUpdating = false;

    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, (event) => {
      const cart = event.cart;
      if (cart) this.handleCartUpdate(cart);
    });

    fetch('/cart.js').then((r) => r.json()).then((cart) => this.handleCartUpdate(cart));
  }

  // Lit les IDs depuis le panel (source de vérité complète) avec fallback sur data-gift-ids
  getAllGiftIds() {
    const selector = document.querySelector('cart-gift-selector');
    if (selector) {
      const ids = [...selector.querySelectorAll('[data-action="select-gift"]')]
        .map((btn) => parseInt(btn.dataset.variantId))
        .filter(Boolean);
      if (ids.length > 0) return ids;
    }
    return this.GIFT_IDS;
  }

  getGiftInCart(cart) {
    const ids = this.getAllGiftIds();
    return cart.items.find((item) => ids.includes(item.variant_id));
  }

  getSections() {
    const sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } })
    );
    return sections;
  }

  updateCart(updates) {
    const sections = this.getSections();
    const body = JSON.stringify({ updates, sections });
    fetch(FoxTheme.routes.cart_update_url, { ...FoxTheme.utils.fetchConfig(), ...{ body } })
      .then((r) => r.json())
      .then((cart) => {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart });
      });
  }

  handleCartUpdate(cart) {
    if (this.isUpdating) return;

    const total = cart.total_price;
    const giftItem = this.getGiftInCart(cart);

    if (total >= this.GIFT_THRESHOLD && !giftItem) {
      if (localStorage.getItem('gift_refused') === 'true') return;

      this.isUpdating = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: this.DEFAULT_GIFT_ID, quantity: 1 }),
      })
        .then((r) => r.json())
        .then(() => this.updateCart({}))
        .finally(() => { this.isUpdating = false; });
    } else if (total < this.GIFT_THRESHOLD && giftItem) {
      localStorage.removeItem('gift_refused');
      this.isUpdating = true;
      this.updateCart({ [giftItem.variant_id]: 0 });
      setTimeout(() => { this.isUpdating = false; }, 1000);
    }
  }
}

customElements.define('cart-free-gift', CartFreeGift);
